export const seodata = {
  home: {
    title: "Circadence | Cyber Range Training & Cyber Security Learning",
    description: "Build cyber skills hands-on with Project Ares cyber range platform.",
    keywords: "cyber training, cyber ranges, cyber security",
  },
  store: {
    title: "Project Ares by Circadence",
    description: "Hands-on Cyber Security Training and Learning for Individuals and Organizations. Subscriptions to fit your cyber readiness goals.",
    keywords: "Project Ares, cyber training, cyber ranges, cyber security, learn cyber security, cyber ranges; Circadence ",
  },
  protect:{
    title: "Protect Your Organization |Cyber Training for Enterprises",
    description: "Project Ares for cyber security teams empowers professionals to build skills on cyber ranges using hands-on scenarios. Train anytime, anywhere.",
    keywords: "cyber security, cyber ranges, cyber range training, cyber training, cyber security training, cyber readiness",
  },
 learn:{
    title: "Learn Cyber Security with Project Ares",
    description: "Build cyber skills and competencies to start or enter into a career in cyber security. Gain hands-on experience using cyber ranges.",
    keywords: "cyber security, cyber learning, cyber security education, cyber range labs, cyber learning labs",
  },

  teach:{
    title: "Teach Cyber Security",
    description: "Academic institutions worldwide use the Project Ares platform in the cyber security classroom to engage students in hands-on learning using real cyber ranges. ",
    keywords: "cyber security, cyber learning, cyber security education, cyber range labs, cyber learning labs",
  },
improve:{
    title: "Improve Cyber Security Skills with Project Ares",
    description: "Cyber Training for Professionals. Build cyber skills and compentencies. Advance in your cyber profession. ",
    keywords: "cyber security, learn cyber security, cyber security training, cyber ranges, cyber range training, professional cyber training",
  },

  fsi:{
    title: "Cyber Training for Financial Services Institutions",
    description: "Project Ares hands-on cyber range training for financial cyber security professionals.",
    keywords: "cyber security, cyber training, financial services institutions, finance cyber training, cyber range training ",
  },

  tech:{
    title: "Cyber Training for Technology Companies",
    description: "Project Ares hands-on cyber range training for technology cyber security professionals.",
    keywords: "cyber security, cyber training, technology cyber security, cyber training, cyber range training ",
  },
gov:{
    title: "Cyber Training for Government Agencies",
    description: "Project Ares hands-on cyber range training for federal or regional government professionals. ",
    keywords: "cyber security, cyber training, government cyber security, cyber training, cyber range training",
  },
  hr:{
    title: "Cyber Security Talent Recruitment and Skills Assessment",
    description: "Project Ares for Talent Evaluation by Human Resources and Hiring Managers.",
    keywords: "cyber security, cyber training, cyber security, cyber training, cyber skills assessment, cyber talent acquisition, cyber security skills assessment, cyber talent evaluation, hiring cyber talent  ",
  },

  cyberbridge: {
    title: "Circadence | CyberBridge Learning Portal",
    description: "CyberBridge is the single sign-on portal for Circadence clients.",
  },
  covid:{
    title: "Circadence | Our Commitment during COVID-19",
    description: "Circadence's commitment to cyber training and readiness during COVID-19.",
    keywords: "covid, circadence, corona virus ",
  },
}
